import { useSearchParams } from 'react-router-dom'
import { Card, Button } from '@/components/ui'
import { Header, Footer } from '@/components/layout'

export default function Success() {
  const [searchParams] = useSearchParams()
  const authCode = searchParams.get('authCode')

  return (
    <div className="min-h-screen flex flex-col bg-neutral-50">
      <Header />

      <main className="flex-1 w-full max-w-2xl mx-auto px-4 py-8 md:py-12">
        <div className="fade-in">
          <Card variant="elevated" padding="lg">
            <div className="text-center py-8">
              {/* Success Icon */}
              <div className="w-20 h-20 mx-auto mb-6 bg-green-100 flex items-center justify-center">
                <svg
                  className="w-10 h-10 text-green-600"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={1.5}
                    d="M5 13l4 4L19 7"
                  />
                </svg>
              </div>

              {/* Title */}
              <h3 className="text-green-700 mb-3">Payment Successful!</h3>

              {/* Message */}
              <p className="text-neutral-600 max-w-md mx-auto mb-6">
                Thank you for your payment. Your reservation has been confirmed
                and you will receive a confirmation email shortly.
              </p>

              {/* Authorization Code */}
              {authCode && (
                <div className="inline-flex items-center gap-2 px-4 py-2 bg-neutral-100 mb-6">
                  <span className="text-sm text-neutral-500 uppercase tracking-wide">
                    Authorization Code:
                  </span>
                  <span className="font-mono font-medium text-neutral-900">
                    {authCode}
                  </span>
                </div>
              )}

              {/* Actions */}
              <div className="space-y-3">
                <a href="https://nestrentalapartments.com">
                  <Button variant="primary" size="lg">
                    Return to NEST Website
                  </Button>
                </a>
              </div>

              {/* Divider */}
              <div className="my-8 border-t border-neutral-200" />

              {/* Next Steps */}
              <div className="text-left max-w-md mx-auto">
                <h4 className="text-neutral-900 mb-3">What happens next?</h4>
                <ul className="space-y-2 text-sm text-neutral-600">
                  <li className="flex items-start gap-2">
                    <svg
                      className="w-5 h-5 text-green-500 flex-shrink-0 mt-0.5"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={1.5}
                        d="M5 13l4 4L19 7"
                      />
                    </svg>
                    <span>
                      You will receive a payment confirmation email within a few
                      minutes
                    </span>
                  </li>
                  <li className="flex items-start gap-2">
                    <svg
                      className="w-5 h-5 text-green-500 flex-shrink-0 mt-0.5"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={1.5}
                        d="M5 13l4 4L19 7"
                      />
                    </svg>
                    <span>
                      Your reservation status will be updated in our system
                    </span>
                  </li>
                  <li className="flex items-start gap-2">
                    <svg
                      className="w-5 h-5 text-green-500 flex-shrink-0 mt-0.5"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={1.5}
                        d="M5 13l4 4L19 7"
                      />
                    </svg>
                    <span>
                      We will send you check-in details closer to your arrival
                      date
                    </span>
                  </li>
                </ul>
              </div>
            </div>
          </Card>

          {/* Contact */}
          <div className="mt-6 text-center text-sm text-neutral-500">
            <p>
              Questions about your reservation?{' '}
              <a
                href="mailto:reservas@nestrentalapartments.com"
                className="text-neutral-900 hover:underline"
              >
                Contact us
              </a>
            </p>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  )
}
